// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
}
:host.horizontal-alignment-left {
  justify-content: flex-start;
}
:host.horizontal-alignment-center {
  justify-content: center;
}
:host.horizontal-alignment-right {
  justify-content: flex-end;
}
:host.vertical-alignment-left {
  align-items: flex-start;
}
:host.vertical-alignment-center {
  align-items: center;
}
:host.vertical-alignment-right {
  align-items: flex-end;
}

.image-container img.image-aligned.horizontal-left {
  object-position: left top;
}
.image-container img.image-aligned.horizontal-center {
  object-position: center top;
}
.image-container img.image-aligned.horizontal-right {
  object-position: right top;
}
.image-container img.image-aligned.vertical-left {
  object-position: left top;
}
.image-container img.image-aligned.vertical-center {
  object-position: left center;
}
.image-container img.image-aligned.vertical-right {
  object-position: left bottom;
}
.image-container img.image-aligned.horizontal-left.vertical-left {
  object-position: left top;
}
.image-container img.image-aligned.horizontal-left.vertical-center {
  object-position: left center;
}
.image-container img.image-aligned.horizontal-left.vertical-right {
  object-position: left bottom;
}
.image-container img.image-aligned.horizontal-center.vertical-left {
  object-position: center top;
}
.image-container img.image-aligned.horizontal-center.vertical-center {
  object-position: center center;
}
.image-container img.image-aligned.horizontal-center.vertical-right {
  object-position: center bottom;
}
.image-container img.image-aligned.horizontal-right.vertical-left {
  object-position: right top;
}
.image-container img.image-aligned.horizontal-right.vertical-center {
  object-position: right center;
}
.image-container img.image-aligned.horizontal-right.vertical-right {
  object-position: right bottom;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-image/storyblok-image.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AAEE;EACE,2BAAA;AAAJ;AAGE;EACE,uBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,uBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,qBAAA;AALJ;;AAeM;EACE,yBAAA;AAZR;AAeM;EACE,2BAAA;AAbR;AAgBM;EACE,0BAAA;AAdR;AAkBM;EACE,yBAAA;AAhBR;AAmBM;EACE,4BAAA;AAjBR;AAoBM;EACE,4BAAA;AAlBR;AAsBM;EACE,yBAAA;AApBR;AAuBM;EACE,4BAAA;AArBR;AAwBM;EACE,4BAAA;AAtBR;AAyBM;EACE,2BAAA;AAvBR;AA0BM;EACE,8BAAA;AAxBR;AA2BM;EACE,8BAAA;AAzBR;AA4BM;EACE,0BAAA;AA1BR;AA6BM;EACE,6BAAA;AA3BR;AA8BM;EACE,6BAAA;AA5BR","sourcesContent":[":host {\n  display: flex;\n  \n  // Host-level alignment classes for the component container\n  &.horizontal-alignment-left {\n    justify-content: flex-start;\n  }\n  \n  &.horizontal-alignment-center {\n    justify-content: center;\n  }\n  \n  &.horizontal-alignment-right {\n    justify-content: flex-end;\n  }\n  \n  &.vertical-alignment-left {\n    align-items: flex-start;\n  }\n  \n  &.vertical-alignment-center {\n    align-items: center;\n  }\n  \n  &.vertical-alignment-right {\n    align-items: flex-end;\n  }\n}\n\n// Image container styling\n.image-container {\n  \n  img {\n    &.image-aligned {\n        // Horizontal alignment classes for the img element (default to top when only horizontal is set)\n      &.horizontal-left {\n        object-position: left top;\n      }\n      \n      &.horizontal-center {\n        object-position: center top;\n      }\n      \n      &.horizontal-right {\n        object-position: right top;\n      }\n      \n      // Vertical alignment classes for the img element (default to left when only vertical is set)\n      &.vertical-left {\n        object-position: left top;\n      }\n      \n      &.vertical-center {\n        object-position: left center;\n      }\n      \n      &.vertical-right {\n        object-position: left bottom;\n      }\n      \n      // Combined alignment classes\n      &.horizontal-left.vertical-left {\n        object-position: left top;\n      }\n      \n      &.horizontal-left.vertical-center {\n        object-position: left center;\n      }\n      \n      &.horizontal-left.vertical-right {\n        object-position: left bottom;\n      }\n      \n      &.horizontal-center.vertical-left {\n        object-position: center top;\n      }\n      \n      &.horizontal-center.vertical-center {\n        object-position: center center;\n      }\n      \n      &.horizontal-center.vertical-right {\n        object-position: center bottom;\n      }\n      \n      &.horizontal-right.vertical-left {\n        object-position: right top;\n      }\n      \n      &.horizontal-right.vertical-center {\n        object-position: right center;\n      }\n      \n      &.horizontal-right.vertical-right {\n        object-position: right bottom;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
